var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNext(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59304 0.527071C7.6916 0.493248 7.79827 0.491065 7.89813 0.520827C7.998 0.550589 8.08607 0.610809 8.15003 0.69307L11.65 5.19304C11.7183 5.28081 11.7554 5.38884 11.7554 5.50004C11.7554 5.61124 11.7183 5.71927 11.65 5.80704L8.15003 10.307C8.08604 10.3892 7.99799 10.4493 7.89817 10.479C7.79835 10.5087 7.69174 10.5065 7.59323 10.4727C7.49472 10.4389 7.40922 10.3752 7.34868 10.2905C7.28814 10.2057 7.25558 10.1042 7.25554 10V8.00503C4.56606 8.06103 3.27406 8.57152 2.62507 9.12652C2.00807 9.65402 1.89507 10.2745 1.77757 10.9245L1.74707 11.092C1.72464 11.2119 1.65917 11.3194 1.563 11.3943C1.46683 11.4693 1.34659 11.5065 1.22488 11.4991C1.10318 11.4916 0.988404 11.4398 0.902159 11.3536C0.815914 11.2675 0.764141 11.1527 0.75658 11.031C0.67058 9.65702 0.79958 7.66603 1.77007 6.00054C2.71207 4.38405 4.40806 3.14105 7.25554 3.01106V1.00007C7.25551 0.895894 7.28802 0.794312 7.34853 0.709512C7.40904 0.624711 7.49452 0.560928 7.59304 0.527071V0.527071Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNext);
export default __webpack_public_path__ + "static/media/ic_next.901a928e.svg";
export { ForwardRef as ReactComponent };